// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1xoku","content":"ManualTimeModal_content__1jh8R"};